<template>
  <BaseDataIterator
    ref="dataList"
    :service="fetchContacts"
    :filter-options="filterOptions"
    :default-query-params="{ filter: queryFilter }"
    disable-search
    :disable-filters="disabled"
    flat
  >
    <template #default="{ data }">
      <BaseDataTable :data="data">
        <template #default="{ item }">
          <RecipientListItem :contact="item" />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountContactsClient } from '@/api/clients';
import contactFilters from '@/filters/contact';
import RecipientListItem from './RecipientListItem.vue';

export default {
  components: {
    RecipientListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    queryFilter: {
      type: Object,
      default: () => ({}),
    },
    disabled: Boolean,
  },
  data() {
    return {
      filterOptions: contactFilters(this.accountId),
    };
  },
  methods: {
    async fetchContacts(params = {}) {
      try {
        const response = await accountContactsClient.list(this.accountId, {
          ...params,
          include: 'primaryPhoneNumber',
          page: {
            number: params?.page || 1,
            size: 5,
          },
        });

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
